"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyChangeStatusReason = exports.PolicyChangeStatus = exports.PolicyChangeType = void 0;
var PolicyChangeType;
(function (PolicyChangeType) {
    PolicyChangeType["AUDIT"] = "AUDIT";
    PolicyChangeType["ADD"] = "ADD";
    PolicyChangeType["CANCEL"] = "CANCEL";
    PolicyChangeType["CHANGE"] = "CHANGE";
    PolicyChangeType["DELETE"] = "DELETE";
    PolicyChangeType["POLICY_START"] = "POLICY_START";
    PolicyChangeType["BILLING_RECONCILIATION"] = "BILLING_RECONCILIATION";
})(PolicyChangeType = exports.PolicyChangeType || (exports.PolicyChangeType = {}));
var PolicyChangeStatus;
(function (PolicyChangeStatus) {
    PolicyChangeStatus["PENDING"] = "PENDING";
    PolicyChangeStatus["CONFIRMED"] = "CONFIRMED";
    PolicyChangeStatus["CANCELLED"] = "CANCELLED";
})(PolicyChangeStatus = exports.PolicyChangeStatus || (exports.PolicyChangeStatus = {}));
var PolicyChangeStatusReason;
(function (PolicyChangeStatusReason) {
    PolicyChangeStatusReason["CREATED"] = "CREATED";
    PolicyChangeStatusReason["CONFIRMED"] = "CONFIRMED";
    PolicyChangeStatusReason["CANCELLED"] = "CANCELLED";
})(PolicyChangeStatusReason = exports.PolicyChangeStatusReason || (exports.PolicyChangeStatusReason = {}));
//# sourceMappingURL=policy-change.js.map